export default {"src":"/_next/static/media/telegram-color-icon.22df2cf3.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};